import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const merge = (...values: ClassValue[]) => twMerge(clsx(values));

export const cn = merge;

export const mergeClassAttributes = <
  T extends { cn?: string; className?: string },
>(
  props: T,
  classes: string | string[] = [],
) => merge(classes, props.cn, props.className);

export const hover = (className: string): string =>
  className
    .split(' ')
    .map((c) => `hover:${c}`)
    .join(' ');
